var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof dksfrontend_shared_components !== "undefined") return resolve();
	__webpack_require__.l("https://app-dks-frontend-shared-components.p014.aws.cldsvc.net/remoteEntry.js", (event) => {
		if(typeof dksfrontend_shared_components !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "dksfrontend_shared_components");
}).then(() => (dksfrontend_shared_components));